import { SET_IS_COORDINATION_GROUP } from 'actions';

export default function SetIsCoordinationGroup(value) {
  return (dispatch) => dispatch({
    type: SET_IS_COORDINATION_GROUP,
    value,
  });
}
